import React, { useRef } from 'react'
import { PimBlock } from './PimBlock'
import { Margin } from '../../Margin'

export const FullStructure = ({ isGeneral, pimData, takePrintVersion }) => {
  const ref = useRef(null)

  const handleSubmit = () => {
    takePrintVersion(pimData.topics, pimData.modules, pimData.cases, ref)
  }

  return (
    <>
      <Margin bottom='22px'>
        <div className="text-center">
          <label>Блок 1. {isGeneral ? 'Задания базового уровня сложности' : 'Темы'}</label>
        </div>
        <PimBlock name={isGeneral ? '' : 'Тема'} blockData={pimData.topics} />
      </Margin>

      <Margin bottom='22px'>
        <div className="text-center">
          <label>Блок 2. {isGeneral ? 'Задания повышенного уровня сложности' : 'Модули'}</label>
        </div>
        <PimBlock name={isGeneral ? '' : 'Модуль'} blockData={pimData.modules} />
        {!isGeneral && (
          <>
            <label>Количество модулей: {pimData.modules.length}</label>
            <div>Примечание: Один модуль может содержать несколько тем.</div>
          </>
        )}
      </Margin>

      {!isGeneral && (
        <>
          <Margin bottom='22px'>
            <div className="text-center">
              <label>Блок 3. Кейс-задания</label>
            </div>
            <label>Количество кейс-заданий: {pimData.cases.length}</label>
            <div>Примечание: Одно кейс-задание может объединять несколько модулей.</div>
          </Margin>

          <a className="btn btn-primary" onClick={handleSubmit} >
            <span className="glyphicon glyphicon-print" /> Версия для печати
                    </a>
          <a style={{ display: 'none' }} ref={ref}></a>
        </>
      )}
    </>
  )
}
